import { lazy } from 'react';

// Lazy load other public page components
export const ErrorComponent = lazy(() => import('@/app/pages/error-component'));

export const ForgotPassword = lazy(() => import('@/features/auth/forgot/forgot-password'));

export const Marketing = lazy(() => import('@/features/marketing/marketing'));

export const ShopifyNewSubscriptionPlans = lazy(
  () => import('@/features/shopify/new-subscription/shopify-new-subscription-plans')
);

export const ShopifyLoginV2 = lazy(() => import('@/features/shopify/shopify-login/shopify-login'));

export const ShopifyOTP = lazy(() => import('@/features/shopify/shopify-otp/shopify-otp'));

export const ShopifyRegistration = lazy(() => import('@/features/shopify/shopify-registration/shopify-registration'));

export const AcceptInvitation = lazy(() => import('@/features/team/accept-invitation/accept-invitation'));

// Stripe signup flow pages (legacy)
export const SignUp = lazy(() => import('@/features/signup/legacy/sign-up'));

export const OTPVerification = lazy(() => import('@/features/auth/otp/otp-verification'));

export const Payment = lazy(() => import('@/features/billing/payment/payment'));

export const PaymentVerifying = lazy(() => import('@/features/billing/payment/payment-verifying'));

// New signup flow pages (SignUpPage is eagerly loaded above)
export const SignUpOTP = lazy(() => import('@/features/signup/sign-up-otp'));

export const SignUpCompany = lazy(() => import('@/features/signup/sign-up-company'));

export const SignUpContinue = lazy(() => import('@/features/signup/sign-up-continue'));

export const SignUpPlans = lazy(() => import('@/features/signup/sign-up-plans'));

export const SignUpPayment = lazy(() => import('@/features/signup/sign-up-payment'));

export const SignUpPaymentVerifying = lazy(() => import('@/features/signup/sign-up-payment-verifying'));

export const SignUpResumeError = lazy(() => import('@/features/signup/sign-up-resume-error-page'));
